import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  homeSpecialOffer: {
    data: [],
    total: "",
  },
  voucherDetail: {},
  myVoucherDetail: {},
  voucherDetailMedia: {
    data: [],
    total: 0,
    offset: 0,
    limit: 10,
    hasMore: false,
    isLoadingVoucher: false,
  },
  myVoucherList: {
    available: {
      data: [],
      total: 0,
      offset: 0,
      limit: 12,
      isLoadingVoucher: false,
      hasMore: true,
    },
    history: {
      data: [],
      total: 0,
      offset: 0,
      limit: 12,
      isLoadingVoucher: false,
      hasMore: true,
    },
    all: {
      data: [],
      total: 0,
      offset: 0,
      limit: 12,
      isLoadingVoucher: false,
      hasMore: true,
    },
  },
  voucherList: {
    cash: {
      data: [],
      total: 0,
      offset: 0,
      limit: 10,
      isLoadingVoucher: false,
      hasMore: true,
    },
    food: {
      data: [],
      total: 0,
      offset: 0,
      limit: 10,
      isLoadingVoucher: false,
      hasMore: true,
    },
    discount: {
      data: [],
      total: 0,
      offset: 0,
      limit: 10,
      isLoadingVoucher: false,
      hasMore: true,
    },
    history: {
      data: [],
      total: 0,
      offset: 0,
      limit: 10,
      isLoadingVoucher: false,
      hasMore: true,
    },
    lolol: {
      data: [],
      total: 0,
      offset: 0,
      limit: 10,
      isLoadingVoucher: false,
      hasMore: true,
    },
    mall: {
      data: [],
      total: 0,
      offset: 0,
      limit: 10,
      isLoadingVoucher: false,
      hasMore: true,
    },
    rest_all: {
      data: [],
      total: 0,
      offset: 0,
      limit: 10,
      isLoadingVoucher: false,
      hasMore: true,
    },
  },
  voucher_refund: false,
  voucher_redeem: false,
  buyVoucher: {
    data: "",
    success: false,
  },
  loadAllVoucher: {
    data: [],
    total: 0,
    offset: 0,
    limit: 10,
    isLoadingVoucher: false,
    hasMore: true,
  },
  loadPromoVoucher: {
    data: {},
    isLoading: false,
    promo_code: "",
    isFailed: false,
  },
};

export default function voucherReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Home Special Offer
    case actionTypes.HOME_SPECIAL_OFFER:
      return { ...state, homeSpecialOffer: {} };
    case actionTypes.HOME_SPECIAL_OFFER_SUCCESS:
      return {
        ...state,
        homeSpecialOffer: {
          data: action.data.data,
          total: action.data.total,
        },
      };
    // Load Voucher Details
    case actionTypes.LOAD_VOUCHER_DETAILS:
      return { ...INITIAL_STATE, voucherDetail: {} };
    case actionTypes.LOAD_VOUCHER_DETAILS_SUCCESS:
      return {
        ...state,
        voucherDetail: action.data,
      };
    // Load My Voucher Details
    case actionTypes.LOAD_MY_VOUCHER_DETAILS:
      return {
        ...state,
        myVoucherDetail: {},
      };
    case actionTypes.LOAD_MY_VOUCHER_DETAILS_SUCCESS:
      return {
        ...state,
        myVoucherDetail: action.data,
      };
    // Load Food Media
    case actionTypes.LOAD_VOUCHER_FOODMEDIA: {
      let voucherDetailMedia = { ...state.voucherDetailMedia };
      voucherDetailMedia.offset = action.data.offset;
      voucherDetailMedia.limit = action.data.limit;
      voucherDetailMedia.isLoadingVoucher = true;
      // voucherDetailMedia.data = [
      //   ...voucherDetailMedia.data,
      //   ...action.data.data
      // ];
      return {
        ...state,
        voucherDetailMedia: voucherDetailMedia,
      };
    }
    case actionTypes.LOAD_VOUCHER_FOODMEDIA_SUCCESS: {
      let voucherDetailMedia = { ...state.voucherDetailMedia };
      // voucherDetailMedia.data = [
      //   ...voucherDetailMedia.data,
      //   ...action.data.data
      // ];
      voucherDetailMedia.data = action.data.data;
      voucherDetailMedia.isLoadingVoucher = false;
      voucherDetailMedia.total = action.total;
      voucherDetailMedia.hasMore = true;

      if (
        parseInt(voucherDetailMedia.offset) + 10 >= voucherDetailMedia.total ||
        voucherDetailMedia.data.length === 0 ||
        voucherDetailMedia.data.length < voucherDetailMedia.limit
      ) {
        voucherDetailMedia.hasMore = false;
      }

      return {
        ...state,
        voucherDetailMedia: voucherDetailMedia,
      };
    }
    // MyVoucherList
    case actionTypes.GET_MY_VOUCHER_LIST: {
      let myVoucherList = cloneDeep(state.myVoucherList);
      let data;

      if (action.data.status) {
        data = myVoucherList[action.data.status];
      } else {
        data = myVoucherList.all;
      }
      data.offset = action.data.offset;
      data.limit = action.data.limit;
      data.isLoadingVoucher = true;
      data.hasMore = true;

      if (action.data.status) {
        myVoucherList[action.data.status] = data;
      } else {
        myVoucherList.all = data;
      }
      return {
        ...state,
        myVoucherList,
      };
    }
    case actionTypes.GET_MY_VOUCHER_LIST_SUCCESS: {
      let myVoucherList = cloneDeep(state.myVoucherList);
      let data;

      if (action.filterData.status) {
        data = myVoucherList[action.filterData.status];
      } else {
        data = myVoucherList.all;
      }

      if (data.offset === 0) {
        data.data = action.data.data;
      } else {
        data.data = [...data.data, ...action.data.data];
      }

      data.isLoadingVoucher = false;
      data.hasMore = true;
      data.total = action.data.total;

      if (parseInt(data.offset) >= data.total) {
        data.hasMore = false;
      }
      if (action.filterData.status) {
        myVoucherList[action.data.status] = data;
      } else {
        myVoucherList.all = data;
      }
      return {
        ...state,
        myVoucherList,
      };
    }
    case actionTypes.GET_PROMO_FAIL: {
      return {
        ...state,
        loadPromoVoucher: {
          data: {},
          isLoading: false,
          promo_code: "",
          isFailed: true,
        },
      };
    }
    case actionTypes.CLEAR_PROMO: {
      return {
        ...state,
        loadPromoVoucher: {
          data: {},
          isLoading: false,
          promo_code: action.promo_code ? action.promo_code : "",
          isFailed: false,
        },
      };
    }
    case actionTypes.GET_PROMO: {
      // action.data;
      return {
        ...state,
        loadPromoVoucher: {
          data: {},
          isLoading: true,
          promo_code: "",
          isFailed: false,
        },
      };
    }
    case actionTypes.GET_PROMO_SUCCESS: {
      // action.data;
      // action.filterData;
      return {
        ...state,
        loadPromoVoucher: {
          data: action.data.data,
          isLoading: false,
          promo_code: "", //action.filterData.promo_code,
          isFailed: false,
        },
      };
    }
    case actionTypes.REDEEM_VOUCHER: {
      return {
        ...state,
        voucher_redeem: false,
      };
    }
    case actionTypes.REDEEM_VOUCHER_SUCCESS: {
      return {
        ...state,
        voucher_redeem: true,
      };
    }
    case actionTypes.REFUND_VOUCHER: {
      return {
        ...state,
        voucher_refund: false,
      };
    }
    case actionTypes.REFUND_VOUCHER_SUCCESS: {
      return {
        ...state,
        voucher_refund: true,
      };
    }
    case actionTypes.LOAD_VOUCHER_LIST: {
      let voucherList = cloneDeep(state.voucherList);
      const voucherType = action.data.lolol ? "lolol" : action.status;
      const offset = action.data.offset !== undefined ? action.data.offset : 0;
      const limit = action.data.limit !== undefined ? action.data.limit : 0;

      voucherList[voucherType].isLoadingVoucher = true;
      voucherList[voucherType].hasMore = false;
      voucherList[voucherType].offset = offset;
      voucherList[voucherType].limit = limit;

      if (offset === 0) {
        voucherList[voucherType].data = [];
        voucherList[voucherType].total = 0;
      }

      return { ...state, voucherList };
    }
    case actionTypes.LOAD_VOUCHER_LIST_SUCCESS: {
      let voucherList = cloneDeep(state.voucherList);
      const voucherType = action.data.lolol ? "lolol" : action.status;
      const limit = voucherList[voucherType].limit;

      voucherList[voucherType].data = [
        ...voucherList[voucherType].data,
        ...action.data.data,
      ];
      voucherList[voucherType].total = action.data.total;
      voucherList[voucherType].isLoadingVoucher = false;
      voucherList[voucherType].hasMore = true;

      if (action.data.data.length === 0 || action.data.data.length < limit) {
        voucherList[voucherType].hasMore = false;
      }

      return { ...state, voucherList };
    }
    case actionTypes.LOAD_VOUCHER_LIST_FAIL: {
      return {
        ...state,
        voucherList: INITIAL_STATE.voucherList,
      };
    }
    case actionTypes.BUY_VOUCHER: {
      return {
        ...state,
        buyVoucher: {
          data: "",
          success: false,
        },
      };
    }
    case actionTypes.BUY_VOUCHER_SUCCESS: {
      return {
        ...state,
        buyVoucher: {
          data: "",
          success: true,
        },
      };
    }
    case actionTypes.BUY_VOUCHER_FAIL: {
      return {
        ...state,
        buyVoucher: {
          data: action.data,
          success: false,
        },
      };
    }
    case actionTypes.LOAD_ALL_VOUCHER: {
      let loadAllVoucher = { ...state.loadAllVoucher };
      loadAllVoucher.offset = action.data.offset;
      loadAllVoucher.limit = action.data.limit;
      loadAllVoucher.isLoadingVoucher = true;

      if (action.data.offset === 0) {
        loadAllVoucher.data = [];
      }

      return {
        ...state,
        loadAllVoucher,
      };
    }
    case actionTypes.LOAD_ALL_VOUCHER_SUCCESS: {
      let loadAllVoucher = { ...state.loadAllVoucher };

      loadAllVoucher.data = [...loadAllVoucher.data, ...action.data.data];
      loadAllVoucher.isLoadingVoucher = false;
      loadAllVoucher.hasMore = true;
      loadAllVoucher.total = action.data.total;
      if (
        parseInt(loadAllVoucher.offset) >= loadAllVoucher.total ||
        loadAllVoucher.data.length === 0 ||
        loadAllVoucher.data.length < loadAllVoucher.limit
      ) {
        loadAllVoucher.hasMore = false;
      }
      return {
        ...state,
        loadAllVoucher,
      };
    }

    default:
      return state;
  }
}
